// import DateField from 'components/fields/dateField';
// import InputField from 'components/fields/InputField';
// import { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';

// const EnrollmentInfo = ({
//   studentData,
//   handleEnrollmentChange,
//   handleFeesChange,
//   courses,
//   addInstallment,
//   handleInstallmentChange,
//   removeInstallment,
//   setDisable,
//   loadingCourses,
// }) => {
//   const [errors, setErrors] = useState({
//     enrollments: [],
//     fees: {},
//     installments: [],
//   });
//   const navigate = useNavigate();
//   const [balanceMessage, setBalanceMessage] = useState('');

//   const validateEnrollments = () => {
//     return studentData.enrollments.map((enrollment, index) => {
//       const enrollmentErrors = {};

//       if (!enrollment.course || enrollment.course.trim() === '')
//         enrollmentErrors.course = 'Course is required';

//       if (!enrollment.batch || enrollment.batch.trim() === '')
//         enrollmentErrors.batch = 'Batch is required';

//       if (!enrollment.enrollmentDate || enrollment.enrollmentDate.trim() === '')
//         enrollmentErrors.enrollmentDate = 'Enrollment date is required';

//       return enrollmentErrors;
//     });
//   };

//   const validateFees = () => {
//     const feeErrors = {};

//     if (
//       !studentData.fees ||
//       !studentData.fees.totalAmount ||
//       studentData.fees.totalAmount <= 0
//     )
//       feeErrors.totalAmount =
//         'Total amount is required and must be greater than zero';

//     return feeErrors;
//   };

//   const validateInstallments = () => {
//     if (studentData.fees?.isFullPayment) return [];

//     return studentData.fees.installments.map((installment, index) => {
//       const installmentErrors = {};

//       if (!installment.amount || installment.amount <= 0)
//         installmentErrors.amount = 'Installment amount is required';

//       if (!installment.dueDate)
//         installmentErrors.dueDate = 'Due date is required';

//       // Add validation for afterLoanDeduction if isEmiInstallment is true
//       if (
//         installment.isEmiInstallment &&
//         (!installment.afterLoanDeduction || installment.afterLoanDeduction <= 0)
//       )
//         installmentErrors.afterLoanDeduction =
//           'After loan deduction amount is required';

//       return installmentErrors;
//     });
//   };

//   const renderFieldError = (errorMessage) =>
//     errorMessage && (
//       <div className="mt-1 text-sm text-red-500">{errorMessage}</div>
//     );

//   useEffect(() => {
//     const enrollmentErrors = validateEnrollments();
//     const feeErrors = validateFees();
//     const installmentErrors = !studentData.fees?.isFullPayment
//       ? validateInstallments()
//       : [];

//     const newErrors = {
//       enrollments: enrollmentErrors,
//       fees: feeErrors,
//       installments: installmentErrors,
//     };

//     setErrors(newErrors);

//     const hasErrors =
//       enrollmentErrors.some((err) => Object.keys(err).length > 0) ||
//       Object.keys(feeErrors).length > 0 ||
//       installmentErrors.some((err) => Object.keys(err).length > 0);

//     setDisable(hasErrors);
//   }, [studentData, setDisable]);

//   useEffect(() => {
//     if (!studentData.fees?.isFullPayment && studentData.fees?.totalAmount > 0) {
//       const totalAmount = Number(studentData.fees.totalAmount);
//       const currentTotal =
//         studentData.fees.installments?.reduce(
//           (sum, installment) => sum + Number(installment.amount),
//           0
//         ) || 0;

//       const remainingAmount = totalAmount - currentTotal;

//       if (remainingAmount > 0) {
//         setBalanceMessage(
//           `Remaining balance to be added in installments: ₹${remainingAmount}`
//         );
//       } else if (remainingAmount < 0) {
//         setBalanceMessage(
//           `Warning: Installments exceed total amount by ₹${Math.abs(
//             remainingAmount
//           )}`
//         );
//       } else {
//         setBalanceMessage('✓ Installments match the total amount perfectly!');
//       }

//       // Update disable state based on installment total
//       if (remainingAmount !== 0) {
//         setDisable(true);
//       }
//     } else {
//       setBalanceMessage('');
//     }
//   }, [studentData.fees, setDisable]);

//   const enrollment = studentData.enrollments[0];
//   const selectedCourse = courses.find(
//     (course) => course.courseId === enrollment.course
//   );
//   const selectedBatch = selectedCourse?.batches.find(
//     (batch) => batch._id === enrollment.batch
//   );

//   return (
//     <div className="h-full w-full rounded-[20px] px-3 pt-7 text-navy-700 dark:text-white md:px-8">
//       <h4 className="pt-[5px] text-xl font-bold text-navy-700 dark:text-white">
//         Course Enrollments and Fees
//       </h4>

//       {/* {error && (
//         <div className="mb-3 text-red-500">
//           <p>{error}</p>
//         </div>
//       )} */}

//       <div className="mb-6 grid grid-cols-1 gap-4 rounded-lg border border-gray-200 p-4 dark:border-white/10 md:grid-cols-2">
//         <div>
//           <label className="mb-2 block text-sm font-medium text-navy-700 dark:text-white">
//             Course
//           </label>
//           <select
//             onChange={(e) => {
//               if (e.target.value === 'create') {
//                 navigate('/admin/create/course');
//               } else {
//                 handleEnrollmentChange(0, 'course', e.target.value);
//               }
//             }}
//             value={enrollment.course}
//             className="w-full rounded-xl border border-gray-200 p-2.5 text-sm outline-none dark:border-white/10 dark:bg-navy-800 dark:text-white"
//           >
//             <option value="">Select Course</option>
//             {loadingCourses ? (
//               <option>Loading courses...</option>
//             ) : courses.length === 0 ? (
//               <option
//                 className="cursor-pointer font-bold text-brand-500"
//                 value="create"
//               >
//                 No courses available - Click to create
//               </option>
//             ) : (
//               courses.map((course, i) => (
//                 <option key={course.courseId} value={course.courseId}>
//                   {i + 1}. {course.courseName}
//                 </option>
//               ))
//             )}
//           </select>
//           {renderFieldError(errors.enrollments[0]?.course)}
//         </div>

//         <div>
// <label className="mb-2 block text-sm font-medium text-navy-700 dark:text-white">
//   Batch
// </label>
// <select
//   onChange={(e) => handleEnrollmentChange(0, 'batch', e.target.value)}
//   value={enrollment.batch}
//   className="w-full rounded-xl border border-gray-200 p-2.5 text-sm outline-none dark:border-white/10 dark:bg-navy-800 dark:text-white"
// >
//   <option value="">Select Batch</option>
//   {selectedCourse?.batches.map((batch) => (
//     <option key={batch._id} value={batch._id}>
//       Batch {batch.batchNumber} (Start:{' '}
//       {new Date(batch.startDate).toLocaleDateString()})
//     </option>
//   ))}
// </select>
// {renderFieldError(errors.enrollments[0]?.batch)}
//         </div>

//         <div>
//           <DateField
//             label="Enrollment Date"
//             type="date"
//             value={enrollment?.enrollmentDate || ''}
//             onChange={(e) =>
//               handleEnrollmentChange(0, 'enrollmentDate', e.target.value)
//             }
//           />
//           {renderFieldError(errors.enrollments[0]?.enrollmentDate)}
//         </div>

//         <div className="md:col-span-2">
//           <InputField
//             label="Notes"
//             placeholder="Additional Notes"
//             value={enrollment.notes}
//             onChange={(e) => handleEnrollmentChange(0, 'notes', e.target.value)}
//           />
//         </div>
//       </div>

//       {/* Fees Section */}
//       <div className="mt-6">
//         <h6 className="text-md mb-3 font-semibold">Fees :</h6>
//         <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
//           <div>
//             <InputField
//               label="Total Amount"
//               type="text"
//               value={studentData.fees?.totalAmount || ''}
//               onChange={(e) => {
//                 const value = e.target.value;
//                 // Allow only numbers and ensure it's not negative
//                 if (/^\d*\.?\d*$/.test(value)) {
//                   handleFeesChange('totalAmount', value);
//                 }
//               }}
//               maxLength={30}
//             />
//             {renderFieldError(errors.fees.totalAmount)}
//           </div>

//           <div>
//             <label className="mb-2 mt-1 block text-sm font-bold text-navy-700 dark:text-white">
//               Payment Type
//             </label>
//             <select
//               onChange={(e) =>
//                 handleFeesChange('isFullPayment', e.target.value === 'true')
//               }
//               value={studentData.fees?.isFullPayment?.toString() || 'true'}
//               className="w-full rounded-xl border border-gray-200 p-3 text-sm outline-none dark:border-white/10 dark:bg-navy-800 dark:text-white"
//             >
//               <option value="true">Full Payment</option>
//               <option value="false">Installments</option>
//             </select>
//           </div>
//         </div>

//         <p className="text-sm text-navy-700 dark:text-white">
//           Note: This is the total fee for the student. Please refer to the
//           batch's total fee before adding the details.
//         </p>
//         {selectedBatch && selectedBatch.fee && (
//           <div className="mt-4 rounded-lg border border-yellow-400 bg-yellow-100 p-4 dark:bg-yellow-500  md:col-span-2">
//             <p className="text-[16px] font-semibold text-navy-700 dark:text-white">
//               <span className="text-red-600"></span> Fee for this batch:{' '}
//               <strong>₹{selectedBatch.fee}</strong>
//             </p>
//           </div>
//         )}

//         {!studentData.fees?.isFullPayment && (
//           <div className="mt-4">
//             {studentData.fees?.installments?.map((installment, idx) => (
//               <div
//                 key={idx}
//                 className="mb-6 rounded-lg border border-gray-200 p-4 dark:border-white/10"
//               >
//                 <h6 className="mb-2 text-sm font-semibold">
//                   Installment {idx + 1}
//                 </h6>

//                 <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
//                   {/* Amount */}
//                   <div className="flex flex-col">
//                     <InputField
//                       label="Amount"
//                       type="text"
//                       maxLength={30}
//                       value={installment.amount}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         if (/^\d*\.?\d*$/.test(value)) {
//                           handleInstallmentChange(idx, 'amount', value);
//                         }
//                       }}
//                     />
//                     {renderFieldError(errors.installments[idx]?.amount)}
//                   </div>

//                   {/* Due Date */}
//                   <div className="flex flex-col">
//                     <DateField
//                       label="Due Date"
//                       type="date"
//                       value={installment.dueDate}
//                       onChange={(e) =>
//                         handleInstallmentChange(idx, 'dueDate', e.target.value)
//                       }
//                     />
//                     {renderFieldError(errors.installments[idx]?.dueDate)}
//                   </div>

//                   {/* EMI Checkbox */}
//                   <div className="flex items-end">
//                     <div className="flex items-center">
//                       <input
//                         type="checkbox"
//                         id={`isEmiInstallment-${idx}`}
//                         checked={installment.isEmiInstallment || false}
//                         onChange={(e) =>
//                           handleInstallmentChange(
//                             idx,
//                             'isEmiInstallment',
//                             e.target.checked
//                           )
//                         }
//                         className="mr-2 "
//                       />
//                       <label
//                         htmlFor={`isEmiInstallment-${idx}`}
//                         className="text-sm text-navy-700 dark:text-white"
//                       >
//                         EMI Installment
//                       </label>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Second Row: After Loan Deduction (only if EMI is checked) */}
//                 {installment.isEmiInstallment && (
//                   <div className="mt-4 md:w-1/3">
//                     <InputField
//                       label="After Loan Deduction"
//                       type="text"
//                       maxLength={30}
//                       value={installment.afterLoanDeduction || ''}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         if (/^\d*\.?\d*$/.test(value)) {
//                           handleInstallmentChange(
//                             idx,
//                             'afterLoanDeduction',
//                             value
//                           );
//                         }
//                       }}
//                     />
//                     {renderFieldError(
//                       errors.installments[idx]?.afterLoanDeduction
//                     )}
//                   </div>
//                 )}

//                 {/* Remove Button */}
//                 <div className="mt-2 flex justify-end">
//                   <button
//                     onClick={() => removeInstallment(idx)}
//                     className="text-sm text-red-600 hover:text-red-800"
//                   >
//                     Remove Installment
//                   </button>
//                 </div>
//               </div>
//             ))}

//             {/* Balance Message */}
//             {!studentData.fees?.isFullPayment && balanceMessage && (
//               <div
//                 className={`mt-2 ${
//                   balanceMessage.includes('Warning')
//                     ? 'text-yellow-500'
//                     : balanceMessage.includes('✓')
//                     ? 'text-green-500'
//                     : 'text-blue-500'
//                 }`}
//               >
//                 <p>{balanceMessage}</p>
//               </div>
//             )}

//             {/* Add Installment Button */}
//             <button
//               onClick={addInstallment}
//               className="mt-4 rounded-lg bg-brand-500 px-4 py-2 text-white hover:bg-brand-600"
//             >
//               Add Installment
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default EnrollmentInfo;

// import DateField from 'components/fields/dateField';
// import InputField from 'components/fields/InputField';
// import { useEffect, useState } from 'react';

// const EnrollmentInfo = ({
//   studentData,
//   handleEnrollmentChange,
//   handleFeesChange,
//   courses,
//   batchStructures,
//   batches,
//   addInstallment,
//   handleInstallmentChange,
//   removeInstallment,
//   setDisable,
//   loadingCourses,
//   loadingBatchStructures,
//   loadingBatches,
// }) => {
//   const [errors, setErrors] = useState({
//     enrollments: [],
//     fees: {},
//     installments: [],
//   });

//   const [balanceMessage, setBalanceMessage] = useState('');

//   /* ===================== VALIDATION ===================== */

//   const validateEnrollments = () =>
//     studentData.enrollments.map((e) => {
//       const err = {};
//       if (!e.course) err.course = 'Course is required';
//       if (!e.batchStructure) err.batchStructure = 'Batch structure is required';
//       if (!e.batch) err.batch = 'Batch is required';
//       if (!e.enrollmentDate) err.enrollmentDate = 'Enrollment date is required';
//       return err;
//     });

//   const validateFees = () => {
//     const err = {};
//     if (!studentData.fees?.totalAmount || studentData.fees.totalAmount <= 0) {
//       err.totalAmount = 'Total amount must be greater than zero';
//     }
//     return err;
//   };

//   const validateInstallments = () => {
//     if (studentData.fees?.isFullPayment) return [];
//     return studentData.fees.installments.map((i) => {
//       const err = {};
//       if (!i.amount || i.amount <= 0) err.amount = 'Amount required';
//       if (!i.dueDate) err.dueDate = 'Due date required';
//       if (i.isEmiInstallment && !i.afterLoanDeduction)
//         err.afterLoanDeduction = 'Required for EMI';
//       return err;
//     });
//   };

//   const renderError = (msg) =>
//     msg && <p className="mt-1 text-sm text-red-500">{msg}</p>;

//   /* ===================== EFFECTS ===================== */

//   useEffect(() => {
//     const eErr = validateEnrollments();
//     const fErr = validateFees();
//     const iErr = validateInstallments();

//     setErrors({
//       enrollments: eErr,
//       fees: fErr,
//       installments: iErr,
//     });

//     const hasErrors =
//       eErr.some((e) => Object.keys(e).length) ||
//       Object.keys(fErr).length ||
//       iErr.some((e) => Object.keys(e).length);

//     setDisable(hasErrors);
//   }, [studentData]);

//   useEffect(() => {
//     if (!studentData.fees?.isFullPayment) {
//       const total = Number(studentData.fees?.totalAmount || 0);
//       const paid =
//         studentData.fees.installments?.reduce(
//           (s, i) => s + Number(i.amount || 0),
//           0
//         ) || 0;

//       const diff = total - paid;

//       if (diff > 0) setBalanceMessage(`Remaining balance: ₹${diff}`);
//       else if (diff < 0)
//         setBalanceMessage(`Installments exceed by ₹${Math.abs(diff)}`);
//       else setBalanceMessage('✓ Installments match total amount');

//       setDisable(diff !== 0);
//     } else {
//       setBalanceMessage('');
//     }
//   }, [studentData.fees]);

//   /* ===================== DATA ===================== */

//   const enrollment = studentData.enrollments[0];

//   const selectedBatch = batches.find((b) => b._id === enrollment.batch);

//   /* ===================== UI ===================== */

//   return (
//     <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
//       <h4 className="text-xl font-bold">Course Enrollments and Fees</h4>

//       <div className="mt-4 grid gap-4 rounded-lg border p-4 md:grid-cols-2">
//         {/* COURSE */}
//         <div>
//           <label className="block text-sm font-medium">Course</label>
//           <select
//             value={enrollment.course}
//             onChange={(e) =>
//               handleEnrollmentChange(0, 'course', e.target.value)
//             }
//             className="w-full rounded-xl border p-2.5"
//           >
//             <option value="">Select Course</option>
//             {loadingCourses ? (
//               <option>Loading...</option>
//             ) : (
//               courses.map((c) => (
//                 <option key={c._id} value={c._id}>
//                   {c.courseName}
//                 </option>
//               ))
//             )}
//           </select>
//           {renderError(errors.enrollments[0]?.course)}
//         </div>

//         {/* BATCH STRUCTURE */}
//         <div>
//           <label className="block text-sm font-medium">Batch Structure</label>
//           <select
//             value={enrollment.batchStructure}
//             disabled={!enrollment.course}
//             onChange={(e) =>
//               handleEnrollmentChange(0, 'batchStructure', e.target.value)
//             }
//             className="w-full rounded-xl border p-2.5"
//           >
//             <option value="">Select Structure</option>
//             {loadingBatchStructures ? (
//               <option>Loading...</option>
//             ) : (
//               batchStructures.map((bs) => (
//                 <option key={bs._id} value={bs._id}>
//                   {bs.name}
//                 </option>
//               ))
//             )}
//           </select>
//           {renderError(errors.enrollments[0]?.batchStructure)}
//         </div>

//         {/* BATCH */}
//         <div>
//           <label className="block text-sm font-medium">Batch</label>
//           <select
//             value={enrollment.batch}
//             disabled={!enrollment.batchStructure}
//             onChange={(e) => handleEnrollmentChange(0, 'batch', e.target.value)}
//             className="w-full rounded-xl border p-2.5"
//           >
//             <option value="">Select Batch</option>
//             {loadingBatches ? (
//               <option>Loading...</option>
//             ) : (
//               batches.map((b) => {
//                 const locations = b.branches
//                   ?.map((br) => br.name.split(',').pop().trim())
//                   .join(', ');

//                 return (
//                   <option key={b._id} value={b._id}>
//                     Batch {b.batchNumber} (
//                     {new Date(b.startDate).toLocaleDateString()}) — ({locations}
//                     )
//                   </option>
//                 );
//               })
//             )}
//           </select>
//           {renderError(errors.enrollments[0]?.batch)}
//         </div>

//         {/* ENROLLMENT DATE */}
//         <DateField
//           label="Enrollment Date"
//           value={enrollment.enrollmentDate}
//           onChange={(e) =>
//             handleEnrollmentChange(0, 'enrollmentDate', e.target.value)
//           }
//         />
//       </div>

//       {/* BATCH FEE */}
//       {selectedBatch?.fees && (
//         <div className="mt-4 rounded-lg border bg-yellow-100 p-4">
//           <strong>Batch Fee: ₹{selectedBatch.fees}</strong>
//         </div>
//       )}

//       {/* FEES + INSTALLMENTS → KEEP YOUR EXISTING CODE BELOW */}
//     </div>
//   );
// };

// export default EnrollmentInfo;

import DateField from 'components/fields/dateField';
import InputField from 'components/fields/InputField';
import { useEffect, useState, useCallback } from 'react';

const EnrollmentInfo = ({
  studentData,
  handleEnrollmentChange,
  handleFeesChange,
  courses,
  batchStructures,
  batches,
  addInstallment,
  handleInstallmentChange,
  removeInstallment,
  setDisable,
  loadingCourses,
  loadingBatchStructures,
  loadingBatches,
  handleInputChange,
}) => {
  const [errors, setErrors] = useState({
    enrollments: [],
    fees: {},
    installments: [],
  });

  const [balanceMessage, setBalanceMessage] = useState('');

  /* ===================== VALIDATION ===================== */

  const validateEnrollments = useCallback(
    () =>
      studentData.enrollments.map((e) => {
        const err = {};
        if (!e.course) err.course = 'Course is required';
        if (!e.batchStructure) err.batchStructure = 'Batch structure is required';
        if (!e.batch) err.batch = 'Batch is required';
        if (!e.enrollmentDate) err.enrollmentDate = 'Enrollment date is required';
        return err;
      }),
    [studentData.enrollments]
  );

  const validateFees = useCallback(() => {
    const err = {};
    if (!studentData.fees?.totalAmount || studentData.fees.totalAmount <= 0) {
      err.totalAmount = 'Total amount must be greater than zero';
    }
    return err;
  }, [studentData.fees?.totalAmount]);

  const validateInstallments = useCallback(() => {
    if (studentData.fees?.isFullPayment) return [];
    return studentData.fees.installments.map((i) => {
      const err = {};
      if (!i.amount || i.amount <= 0) err.amount = 'Amount required';
      if (!i.dueDate) err.dueDate = 'Due date required';
      if (i.isEmiInstallment && !i.afterLoanDeduction)
        err.afterLoanDeduction = 'Required for EMI';
      return err;
    });
  }, [studentData.fees?.isFullPayment, studentData.fees?.installments]);

  const renderError = (msg) =>
    msg && <p className="mt-1 text-sm text-red-500">{msg}</p>;

  /* ===================== EFFECTS ===================== */

  useEffect(() => {
    const eErr = validateEnrollments();
    const fErr = validateFees();
    const iErr = validateInstallments();

    setErrors({
      enrollments: eErr,
      fees: fErr,
      installments: iErr,
    });

    const hasErrors =
      eErr.some((e) => Object.keys(e).length) ||
      Object.keys(fErr).length ||
      iErr.some((e) => Object.keys(e).length);

    setDisable(hasErrors);
  }, [
    studentData,
    setDisable,
    validateEnrollments,
    validateFees,
    validateInstallments,
  ]);

  useEffect(() => {
    if (!studentData.fees?.isFullPayment) {
      const total = Number(studentData.fees?.totalAmount || 0);
      const paid =
        studentData.fees.installments?.reduce(
          (s, i) => s + Number(i.amount || 0),
          0
        ) || 0;

      const diff = total - paid;

      if (diff > 0) setBalanceMessage(`Remaining balance: ₹${diff}`);
      else if (diff < 0)
        setBalanceMessage(`Installments exceed by ₹${Math.abs(diff)}`);
      else setBalanceMessage('✓ Installments match total amount');

      setDisable(diff !== 0);
    } else {
      setBalanceMessage('');
    }
  }, [studentData.fees, setDisable]);

  /* ===================== DATA ===================== */

  const enrollment = studentData.enrollments[0];
  const selectedBatch = batches.find((b) => b._id === enrollment.batch);

  /* ===================== UI ===================== */

  return (
    <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
      <h4 className="text-xl font-bold">Course Enrollments and Fees</h4>

      {/* ================= COURSE / BATCH ================= */}
      <div className="mt-4 grid gap-4 rounded-lg border p-4 md:grid-cols-2">
        {/* COURSE */}
        <div>
          <label className="block text-sm font-medium">Course</label>
          <select
            value={enrollment.course}
            onChange={(e) =>
              handleEnrollmentChange(0, 'course', e.target.value)
            }
            className="w-full rounded-xl border p-2.5"
          >
            <option value="">Select Course</option>
            {loadingCourses ? (
              <option>Loading...</option>
            ) : (
              courses.map((c) => (
                <option key={c._id} value={c._id}>
                  {c.courseName}
                </option>
              ))
            )}
          </select>
          {renderError(errors.enrollments[0]?.course)}
        </div>

        {/* BATCH STRUCTURE */}
        <div>
          <label className="block text-sm font-medium">Batch Structure</label>
          <select
            value={enrollment.batchStructure}
            disabled={!enrollment.course}
            onChange={(e) =>
              handleEnrollmentChange(0, 'batchStructure', e.target.value)
            }
            className="w-full rounded-xl border p-2.5"
          >
            <option value="">Select Structure</option>
            {loadingBatchStructures ? (
              <option>Loading...</option>
            ) : (
              batchStructures.map((bs) => (
                <option key={bs._id} value={bs._id}>
                  {bs.name}
                </option>
              ))
            )}
          </select>
          {renderError(errors.enrollments[0]?.batchStructure)}
        </div>

        {/* BATCH */}
        <div>
          <label className="block text-sm font-medium">Batch</label>
          <select
            value={enrollment.batch}
            disabled={!enrollment.batchStructure}
            onChange={(e) => handleEnrollmentChange(0, 'batch', e.target.value)}
            className="w-full rounded-xl border p-2.5"
          >
            <option value="">Select Batch</option>

            {loadingBatches ? (
              <option>Loading...</option>
            ) : (
              batches.map((b) => {
                const batchDisplay = `B${b.batchNumber}`;
                
                const date = new Date(b.startDate);
                const day = date.getDate().toString().padStart(2, '0');
                const month = date.toLocaleString('default', { month: 'short' });
                const year = date.getFullYear().toString().slice(-2);
                const dateDisplay = `${day}${month}${year}`;

                const dayMap = {
                  Monday: 'M',
                  Tuesday: 'T',
                  Wednesday: 'W',
                  Thursday: 'Th',
                  Friday: 'F',
                  Saturday: 'S',
                  Sunday: 'Su',
                };

                const scheduleDisplay = b.daySchedules
                  ?.map((schedule) => {
                    const dayShort = dayMap[schedule.day] || schedule.day;
                    const time = schedule.startTime.replace(':00', '').replace(' ', '');
                    return `${dayShort}-${time}`;
                  })
                  .join(' | ');

                const branchInitials = b.branches
                  ?.map((br) => br.name.split(',').pop().trim()[0])
                  .join('');

                const schedulePart = scheduleDisplay ? `(${scheduleDisplay} )` : '';
                const fullDisplay = `${batchDisplay} | ${dateDisplay} ${schedulePart} ${branchInitials || ''}`.trim();

                return (
                  <option key={b._id} value={b._id}>
                    {fullDisplay}
                  </option>
                );
              })
            )}
          </select>

          {renderError(errors.enrollments[0]?.batch)}
        </div>

        {/* ENROLLMENT DATE */}
        <DateField
          label="Enrollment Date"
          value={enrollment.enrollmentDate}
          onChange={(e) =>
            handleEnrollmentChange(0, 'enrollmentDate', e.target.value)
          }
        />

        {/* NOTES */}
        <div className="md:col-span-2">
          <InputField
            label="Notes"
            value={enrollment.notes || ''}
            onChange={(e) => handleEnrollmentChange(0, 'notes', e.target.value)}
          />
        </div>
      </div>

      {/* ================= BATCH FEE ================= */}
      {selectedBatch?.fees && (
        <div className="mt-4 rounded-lg border bg-yellow-100 p-4">
          <strong>Batch Fee: ₹{selectedBatch.fees}</strong>
        </div>
      )}

      {/* ================= FEES ================= */}
      <div className="mt-6">
        <h6 className="mb-3 font-semibold">Fees</h6>

        <div className="grid gap-4 md:grid-cols-2">
          <InputField
            label="Total Amount"
            value={studentData.fees?.totalAmount || ''}
            onChange={(e) => {
              if (/^\d*$/.test(e.target.value)) {
                handleFeesChange('totalAmount', e.target.value);
              }
            }}
          />
          {renderError(errors.fees?.totalAmount)}

          <div>
            <label className="block text-sm font-medium">Payment Type</label>
            <select
              value={studentData.fees?.isFullPayment ? 'true' : 'false'}
              onChange={(e) =>
                handleFeesChange('isFullPayment', e.target.value === 'true')
              }
              className="w-full rounded-xl border p-2.5"
            >
              <option value="true">Full Payment</option>
              <option value="false">Installments</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium">
              Terms and Condition Format
            </label>
            <select
              value={studentData.termsAndConditionType || 'Job Guarantee Training'}
              onChange={handleInputChange}
              id="termsAndConditionType"
              className="w-full rounded-xl border p-2.5"
            >
              <option value="Job Guarantee Training">
                Job Guarantee Training
              </option>
              <option value="Training only">Training only</option>
              <option value="Bootcamp Training Program">
                Bootcamp Training Program
              </option>
              <option value="Job Assistance Program">
                Job Assistance Program
              </option>
              <option value="Interview Guarantee Program">
                Interview Guarantee Program
              </option>
              <option value="100% Placement Training Program">
                100% Placement Training Program
              </option>
            </select>
          </div>

          {/* STAFF NOTES (internal, not visible to student) */}
          <div className="md:col-span-2">
            <label className="block text-sm font-medium">
              Staff Notes (internal – not visible to student)
            </label>
            <textarea
              id="staffNotes"
              rows={3}
              value={studentData.staffNotes || ''}
              onChange={handleInputChange}
              placeholder="Notes for admin / staff only"
              className="w-full rounded-xl border p-2.5"
            />
          </div>
        </div>

        {/* ================= INSTALLMENTS ================= */}
        {!studentData.fees?.isFullPayment && (
          <div className="mt-4">
            {studentData.fees.installments.map((i, idx) => (
              <div key={idx} className="mb-4 rounded-lg border p-4">
                <h6 className="mb-2 font-semibold">Installment {idx + 1}</h6>

                <div className="grid gap-4 md:grid-cols-3">
                  <InputField
                    label="Amount"
                    value={i.amount}
                    onChange={(e) =>
                      /^\d*$/.test(e.target.value) &&
                      handleInstallmentChange(idx, 'amount', e.target.value)
                    }
                  />
                  {renderError(errors.installments[idx]?.amount)}

                  <DateField
                    label="Due Date"
                    value={i.dueDate}
                    onChange={(e) =>
                      handleInstallmentChange(idx, 'dueDate', e.target.value)
                    }
                  />
                  {renderError(errors.installments[idx]?.dueDate)}

                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      checked={i.isEmiInstallment || false}
                      onChange={(e) =>
                        handleInstallmentChange(
                          idx,
                          'isEmiInstallment',
                          e.target.checked
                        )
                      }
                      className="mr-2"
                    />
                    EMI Installment
                  </div>
                </div>

                {i.isEmiInstallment && (
                  <div className="mt-3 md:w-1/3">
                    <InputField
                      label="After Loan Deduction"
                      value={i.afterLoanDeduction || ''}
                      onChange={(e) =>
                        /^\d*$/.test(e.target.value) &&
                        handleInstallmentChange(
                          idx,
                          'afterLoanDeduction',
                          e.target.value
                        )
                      }
                    />
                    {renderError(errors.installments[idx]?.afterLoanDeduction)}
                  </div>
                )}

                <div className="mt-2 text-right">
                  <button
                    onClick={() => removeInstallment(idx)}
                    className="text-sm text-red-600"
                  >
                    Remove Installment
                  </button>
                </div>
              </div>
            ))}

            {balanceMessage && (
              <p className="mt-2 text-sm font-medium">{balanceMessage}</p>
            )}

            <button
              onClick={addInstallment}
              className="mt-4 rounded-lg bg-blue-600 px-4 py-2 text-white"
            >
              Add Installment
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default EnrollmentInfo;
